(function () {

    angular
        .module('app')
        .service('usersService', usersService);

    usersService.$inject = [
        '$http', 'qitanAiContractService'
    ];


    function usersService($http, qitanAiContractService) {

        function returnData(resp) {
            return resp.data;
        }

        function getClassApiUrl(name, params) {
            return qitanAiContractService.getClassApiUrl(name, params);
        }

        function getClassPolicy(profile) {
            return $http.get(getClassApiUrl('tenantPolicy', { classid : profile.tenant }))
                .then(returnData);
        }

        function modifyClassPolicy(profile, textexpiry) {
            var modification = [
                { op : 'replace', path : '/textClassifierExpiry', value : textexpiry },
            ];
            return $http.patch(getClassApiUrl('tenantPolicy', { classid : profile.tenant }), modification)
                .then(returnData);
        }

        function createTeacher(username, email, password, notes, token) {
            var newteacher = {
                username : username,
                email : email,
                password : password,
                notes : notes,
                turnstile : token
            };

            return $http.post(getClassApiUrl('teachers'), newteacher)
                .then(returnData);
        }


        function deleteClass(profile) {
            return $http.delete(getClassApiUrl('class', { classid : profile.tenant }), {
                params : { confirm : 'true' }
            });
        }

        function getStudentList(profile, group) {
            return $http.get(getClassApiUrl('students', { classid : profile.tenant }), {
                params : { group : group || '' }
            })
                .then(returnData);
        }

        function deleteStudent(profile, tenant) {
            return $http.delete(getClassApiUrl('student', {
                classid : tenant,
                studentid : profile.id
            }));
        }

        function createStudent(userattrs, tenant) {
            var newstudent = {
                username : userattrs.username,
                group : userattrs.group
            };

            return $http.post(getClassApiUrl('students', { classid : tenant }), newstudent)
                .then(returnData);
        }

        function createStudents(tenant, prefix, number, password, group) {
            var bulkCreate = {
                prefix : prefix,
                number : number,
                password : password,
                group : group
            };
            return $http.put(getClassApiUrl('students', { classid : tenant }), bulkCreate)
                .then(returnData);
        }
        function importStudents(tenant, usernames, password, group) {
            var bulkCreate = {
                usernames : usernames,
                password : password,
                group : group
            };
            return $http.put(getClassApiUrl('students', { classid : tenant }), bulkCreate)
                .then(returnData);
        }

        function resetStudentPassword(profile, tenant) {
            return $http.post(getClassApiUrl('studentPassword', {
                classid : tenant,
                studentid : profile.id
            }))
                .then(returnData);
        }
        function resetStudentsPassword(profiles, tenant) {
            var students = profiles.map(function (profile) {
                return {
                    op : 'replace',
                    path : '/password',
                    value : { id : profile.id }
                };
            });
            return $http.patch(getClassApiUrl('students', { classid : tenant }), students)
                .then(returnData);
        }

        function addStudentsToGroup(userids, tenant, group) {
            var students = userids.map(function (userid) {
                return {
                    op : 'replace',
                    path : '/group',
                    value : { group : group, user : userid }
                };
            });
            return $http.patch(getClassApiUrl('students', { classid : tenant }), students)
                .then(returnData);
        }
        function removeStudentsFromGroup(userids, tenant) {
            var students = userids.map(function (userid) {
                return {
                    op : 'remove',
                    path : '/group',
                    value : { user : userid }
                };
            });
            return $http.patch(getClassApiUrl('students', { classid : tenant }), students)
                .then(returnData);
        }

        function deleteStudents(userids, tenant) {
            var students = userids.map(function (userid) {
                return {
                    op : 'remove',
                    path : '/students',
                    value : { user : userid }
                };
            });
            return $http.patch(getClassApiUrl('class', { classid : tenant }), students)
                .then(returnData);
        }

        function createClassGroup(profile, groupname) {
            var modification = [
                { op : 'add', path : '/groups', value : groupname }
            ];
            return $http.patch(getClassApiUrl('class', { classid : profile.tenant }), modification)
                .then(returnData);
        }
        function deleteClassGroup(profile, groupname) {
            var modification = [
                { op : 'remove', path : '/groups', value : groupname }
            ];
            return $http.patch(getClassApiUrl('class', { classid : profile.tenant }), modification)
                .then(returnData);
        }

        function getGeneratedPassword(tenant) {
            return $http.get(getClassApiUrl('passwords', { classid : tenant }))
                .then(returnData);
        }



        function getCredentials(profile, type) {
            return $http.get(getClassApiUrl('credentials', { classid : profile.tenant }), {
                params : { servicetype : type }
            })
                .then(returnData);
        }
        function verifyCredentials(profile, credentials) {
            return $http.get(getClassApiUrl('credential', {
                classid : profile.tenant,
                credentialsid : credentials.id
            }));
        }
        function deleteCredentials(profile, credentials) {
            return $http.delete(getClassApiUrl('credential', {
                classid : profile.tenant,
                credentialsid : credentials.id
            }));
        }
        function addCredentials(credentials, tenant) {
            return $http.post(getClassApiUrl('credentials', { classid : tenant }), credentials)
                .then(returnData);
        }
        function modifyCredentials(credentials, servicetype, credstype, tenant) {
            var update = [
                {
                    op : 'replace',
                    path : '/credstype',
                    value : {
                        servicetype : servicetype,
                        credstype : credstype
                    }
                }
            ];
            return $http.patch(getClassApiUrl('credential', {
                classid : tenant,
                credentialsid : credentials.id
            }), update)
                .then(returnData);
        }


        return {
            createTeacher : createTeacher,

            addCredentials : addCredentials,
            getCredentials : getCredentials,
            modifyCredentials : modifyCredentials,
            verifyCredentials : verifyCredentials,
            deleteCredentials : deleteCredentials,

            getGeneratedPassword : getGeneratedPassword,

            getClassPolicy : getClassPolicy,
            modifyClassPolicy : modifyClassPolicy,

            getStudentList : getStudentList,

            createStudent : createStudent,
            createStudents : createStudents,
            importStudents : importStudents,
            deleteStudent : deleteStudent,
            deleteStudents : deleteStudents,

            resetStudentPassword : resetStudentPassword,
            resetStudentsPassword : resetStudentsPassword,

            addStudentsToGroup : addStudentsToGroup,
            removeStudentsFromGroup : removeStudentsFromGroup,

            createClassGroup : createClassGroup,
            deleteClassGroup : deleteClassGroup,

            deleteClass : deleteClass
        };
    }
})();
